import { DocumentText, Gallery, Grid8, FolderOpen, type Icon } from "iconsax-react";

export type FileCategory = "document" | "image" | "spreadsheet" | "archive";

const CATEGORY_ICONS: Record<FileCategory, Icon> = {
  document: DocumentText,
  image: Gallery,
  spreadsheet: Grid8,
  archive: FolderOpen,
};

export function getFileCategory(contentType: string): FileCategory {
  if (contentType === "application/pdf") return "document";
  if (contentType === "application/msword") return "document";
  if (contentType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return "document";
  if (contentType === "application/vnd.ms-excel") return "spreadsheet";
  if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return "spreadsheet";
  if (contentType.startsWith("image/")) return "image";
  if (contentType === "application/zip") return "archive";
  return "document";
}

export function getCategoryIcon(category: FileCategory): Icon {
  return CATEGORY_ICONS[category];
}

export function canOpenInViewer(contentType: string): boolean {
  return contentType === "application/pdf" || contentType.startsWith("image/");
}

export function humanFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const CONTENT_TYPE_TO_EXT: Record<string, string> = {
  "application/pdf": "PDF",
  "application/msword": "DOC",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
  "image/jpeg": "JPG",
  "image/png": "PNG",
  "image/gif": "GIF",
  "image/webp": "WEBP",
  "application/zip": "ZIP",
};

export function getFileExtensionLabel(contentType: string): string {
  return CONTENT_TYPE_TO_EXT[contentType] ?? "FILE";
}

const CONTENT_TYPE_TO_BG: Record<string, string> = {
  "application/pdf": "bg-red-500/10",
  "application/msword": "bg-blue-500/10",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "bg-blue-500/10",
  "application/vnd.ms-excel": "bg-green-500/10",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "bg-green-500/10",
  "image/jpeg": "bg-yellow-500/10",
  "image/png": "bg-indigo-500/10",
  "image/gif": "bg-pink-500/10",
  "image/webp": "bg-cyan-500/10",
  "application/zip": "bg-grey-500/10",
};

export function getFileCardBgClass(contentType: string): string {
  return CONTENT_TYPE_TO_BG[contentType] ?? "bg-grey-500/10";
}

